import { cn, Typography } from "@suraasa/placebo-ui"
import SuraasaPlusMobileImage from "features/Payment/CartlessSubscriptionFlow/assets/suraasaPlus.webp"
import SuraasaPlus from "features/SuraasaPlus/assets/suraasa-plus-product-card.png"

type Props = {
  className?: string
}

const ProductBanner = (props: Props) => {
  return (
    <div className={cn("flex flex-col", props.className)}>
      <div className="flex flex-wrap items-center gap-2 md:hidden">
        <img
          src={SuraasaPlusMobileImage}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
          }}
          alt="thumbnail"
          height={110}
          width={150}
          className="rounded-lg"
          style={{
            border: "2.56px solid rgba(0, 0, 0, 0.15)",
            boxShadow: "0px 7.67px 19.19px 0px rgba(0, 0, 0, 0.05)",
          }}
        />
        <div className="flex flex-col">
          <Typography variant={"title2"} className="mb-0.5">
            Suraasa Plus
          </Typography>
          <Typography variant={"largeBody"} className=" text-onSurface-600">
            Transform your teaching journey
            <br />
            with one membership
          </Typography>
        </div>
      </div>
      <img
        src={SuraasaPlus}
        alt="thumbnail"
        className="hidden w-full max-w-md rounded-lg md:block"
      />
    </div>
  )
}

export default ProductBanner
